import api from '../../api/axios';

export const SHOPIFY_CHECK_REQUEST = 'SHOPIFY_CHECK_REQUEST';
export const SHOPIFY_CHECK_SUCCESS = 'SHOPIFY_CHECK_SUCCESS';
export const SHOPIFY_CHECK_FAILURE = 'SHOPIFY_CHECK_FAILURE';
export const SHOPIFY_SAVE_REQUEST = 'SHOPIFY_SAVE_REQUEST';
export const SHOPIFY_SAVE_SUCCESS = 'SHOPIFY_SAVE_SUCCESS';
export const SHOPIFY_SAVE_FAILURE = 'SHOPIFY_SAVE_FAILURE';

// Checks whether the current user has any Shopify store(s) connected
// POST /shopify/getUserDataWithStores
export const checkShopifyConnection = () => async (dispatch) => {
  try {
    dispatch({ type: SHOPIFY_CHECK_REQUEST });
    const response = await api.get('shopify/getUserDataWithStores');
    const envelope = response?.data || {};

    // Backend shape: { success, message, data: { user, shopifyStores: [] } }
    const data = envelope?.data || {};
    const stores = Array.isArray(data?.shopifyStores) ? data.shopifyStores : [];
    const isConnected = stores.length > 0;

    const payload = { isConnected, stores, raw: envelope };
    dispatch({ type: SHOPIFY_CHECK_SUCCESS, payload });
    return envelope;
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch Shopify connection status';
    dispatch({ type: SHOPIFY_CHECK_FAILURE, error: message });
    // Avoid throwing so views can render gracefully when API returns 500
    return null;
  }
};

// Saves Shopify credentials, then re-checks connection status
export const saveShopifyKeys = (payload) => async (dispatch) => {
  try {
    dispatch({ type: SHOPIFY_SAVE_REQUEST });
    const response = await api.post('shopify/saveshopifykey', payload);
    dispatch({ type: SHOPIFY_SAVE_SUCCESS, payload: response?.data });
    // After successful save, refresh connection status
    await dispatch(checkShopifyConnection());
    return response?.data;
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to save Shopify keys';
    dispatch({ type: SHOPIFY_SAVE_FAILURE, error: message });
    throw error;
  }
};


